import { useEffect } from 'react';

export function useLocalStoragePersistence({
    goldInventory, personalLoans, goldLoans, accounts, creditCards,
    sgBudgetCycle1, sgBudgetCycle2, lkBudgetDamith, lkBudgetShan,
    sgdRate, lkrRate, usdRate, baseCurrency,
    cycleHistory, cycleOpenedAt, monthlySnapshots,
    investments, invCashSGD, invCashUSD, moneyMarketFunds,
    fixedAssets, monthlyIncomes, financialMilestones,
}) {
    useEffect(() => {
        const MAX_HISTORY = 24;
        const prunedCycleHistory = cycleHistory.slice(0, MAX_HISTORY);
        const prunedSnapshots = monthlySnapshots.slice(0, MAX_HISTORY);

        // Guard: if all primary arrays are empty this is likely the pre-load default
        // state firing before loadData has run. If localStorage already has real data,
        // skip the write — we must not overwrite good data with empty defaults.
        const stateIsEmpty =
            goldInventory.length === 0 &&
            personalLoans.length === 0 &&
            accounts.length === 0 &&
            cycleHistory.length === 0 &&
            investments.length === 0;

        if (stateIsEmpty) {
            const existingRaw = localStorage.getItem('iPlannerData_v3');
            if (existingRaw) {
                try {
                    const existing = JSON.parse(existingRaw);
                    const hasRealData =
                        (existing.goldInventory?.length > 0) ||
                        (existing.personalLoans?.length > 0) ||
                        (existing.accounts?.length > 0) ||
                        (existing.cycleHistory?.length > 0) ||
                        (existing.investments?.length > 0);
                    if (hasRealData) return; // loadData hasn't run yet — skip write
                } catch (_) { /* corrupt localStorage — allow overwrite */ }
            }
        }

        const snapshot = {
            goldInventory,
            personalLoans,
            goldLoans,
            accounts,
            creditCards,
            sgBudgetCycle1,
            sgBudgetCycle2,
            lkBudgetDamith,
            lkBudgetShan,
            sgdRate,
            lkrRate,
            usdRate,
            baseCurrency,
            cycleHistory: prunedCycleHistory,
            cycleOpenedAt,
            monthlySnapshots: prunedSnapshots,
            investments,
            invCashSGD,
            invCashUSD,
            moneyMarketFunds,
            fixedAssets,
            monthlyIncomes,
            financialMilestones,
        };

        const existingRaw = localStorage.getItem('iPlannerData_v3');
        const existingSyncedAt = existingRaw ? (JSON.parse(existingRaw)._syncedAt || null) : null;
        snapshot._syncedAt = existingSyncedAt;

        localStorage.setItem('iPlannerData_v3', JSON.stringify(snapshot));

    }, [goldInventory, personalLoans, goldLoans, accounts, creditCards,
        sgBudgetCycle1, sgBudgetCycle2, lkBudgetDamith, lkBudgetShan,
        sgdRate, lkrRate, usdRate, baseCurrency, cycleHistory, cycleOpenedAt,
        monthlySnapshots, investments, invCashSGD, invCashUSD, moneyMarketFunds,
        fixedAssets, monthlyIncomes, financialMilestones]);
}
